const DNB_DNS_FIELDS = `
        do_not_buy
        do_not_sell`

const buildAccountListQuery = (includeMarginFields: boolean) => /* GraphQL */ `
  query AccountsList(
    $sort: [AccountSort!]
    $limit: Int
    $offset: Int
    $filters: AccountFilters
  ) {
    accounts(sort: $sort, limit: $limit, offset: $offset, filters: $filters) {
      accounts {
        moment_account_id
        moment_organization_id
        custodian_id
        custodian_account_id
        moment_status
        custodian_status
        moment_trading_group_id
        account_type
        tax_state
        account_name
        extra
        compliance_status
        do_not_trade
        do_not_trade_reason
${includeMarginFields ? DNB_DNS_FIELDS : ''}
        statistics {
          timestamp
          total_market_value
          cash_market_value
          tracked_fixed_income_market_value
          percent_uninvested_cash
          average_ytw
          average_book_ytw
          average_maturity_in_years
          average_moodys_rating
          average_sp_rating
          average_coupon
          average_duration
        }
        advisor {
          id
          name
        }
        custodian {
          id
          name
        }
        management_type
        prime_brokerage_enabled
        compliance {
          compliant
          checks {
            ... on MarketValueComplianceCheck {
              type
              compliant
              sleeve_id
              current_market_value
              min_market_value
              max_market_value
              target_market_value
            }
            ... on ModelComplianceCheck {
              type
              compliant
              sleeve_id
              model_id
              constraints
            }
            ... on WeightComplianceCheck {
              type
              compliant
              sleeve_id
              min_weight
              target_weight
              max_weight
              current_weight
            }
          }
        }
        sleeves {
          moment_sleeve_id
          target_allocation
          name
          model_assignment {
            model {
              name
              id
            }
          }
        }
        proposals {
          proposal_id
          status
          created_by
        }
      }
      total_count
      total_fi_market_value
    }
  }
`

export const ACCOUNT_LIST_QUERY = buildAccountListQuery(false)

export const ACCOUNT_LIST_WITH_MARGIN_QUERY = buildAccountListQuery(true)

const ABBREVIATED_ACCOUNT_LIST_MARGIN_FIELDS = `
        margin_indicator
${DNB_DNS_FIELDS}`

const buildAbbreviatedAccountListQuery = (
  includeMarginFields: boolean,
) => /* GraphQL */ `
  query AbbreviatedAccountsList(
    $sort: [AccountSort!]
    $limit: Int
    $offset: Int
    $filters: AccountFilters
    $include_sleeves: Boolean!
    $include_statistics: Boolean!
  ) {
    accounts(sort: $sort, limit: $limit, offset: $offset, filters: $filters) {
      accounts {
        moment_account_id
        custodian_account_id
        account_name
        account_type
        household_id
        management_type
        moment_status
        moment_trading_group_id
        do_not_trade
        do_not_trade_reason
        cash_allocation {
          weight {
            min_allocation
          }
          market_value {
            min_allocation
          }
        }
        cash {
          settled_open_quantity
        }
        custodian {
          id
          name
        }
        prime_brokerage_enabled
${includeMarginFields ? ABBREVIATED_ACCOUNT_LIST_MARGIN_FIELDS : ''}
        sleeves @include(if: $include_sleeves) {
          is_default
          moment_sleeve_id
          name
        }
        statistics @include(if: $include_statistics) {
          cash_market_value
          total_market_value
        }
        extra
      }
      total_count
    }
  }
`

export const ABBREVIATED_ACCOUNT_LIST_QUERY =
  buildAbbreviatedAccountListQuery(false)

export const ABBREVIATED_ACCOUNT_LIST_WITH_MARGIN_QUERY =
  buildAbbreviatedAccountListQuery(true)

export const ACCOUNT_IDS_QUERY = /* GraphQL */ `
  query AccountIds(
    $sort: [AccountSort!]
    $limit: Int
    $offset: Int
    $filters: AccountFilters
  ) {
    accounts(sort: $sort, limit: $limit, offset: $offset, filters: $filters) {
      accounts {
        moment_account_id
        account_name
        sleeves {
          moment_sleeve_id
          is_default
          model_assignment {
            model {
              id
            }
          }
        }
      }
      total_count
    }
  }
`

export const buildAccountDntStatusQuery = (
  includeMarginFields: boolean,
) => /* GraphQL */ `
  query AccountDntStatus($accountIds: [String!]!) {
    accounts(filters: { moment_account_id: { in: $accountIds } }) {
      accounts {
        moment_account_id
        do_not_trade
${includeMarginFields ? DNB_DNS_FIELDS : ''}
        do_not_trade_reason
      }
    }
  }
`
